import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { SalesforceV2Dataset } from 'shell-models-lib';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { IModel } from 'app/model/base/annotation';

export const salesforceV2DatasetAdapts = {
    name: '*',
    properties: {
        ...tabularPropertiesCommonAdapts,
        typeProperties: {
            objectApiName: '*',
            reportId: '*'
        }
    }
};
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceV2Dataset),
    asynchronous: true,
    adapts: salesforceV2DatasetAdapts
})
export class SalesforceV2DatasetAdapter extends TabularTypeDatasetAdapter<SalesforceV2Dataset, Model.DatasetResource> {
    protected model(): IModel {
        return SalesforceV2Dataset.MODEL;
    }

    protected async _toResource(dataset: SalesforceV2Dataset): Promise<Model.DatasetResource> {
        // generally uses `tableNameKeyword` except cw initialization, where tableName is undefined. Fallback to `tableKeyWord`
        return await this._toResourceInternal(dataset, this.model().name, dataset.sourceOption, undefined, dataset.sourceOption);
    }

    protected async _toModel(resource: Model.DatasetResource, dataset?: SalesforceV2Dataset): Promise<SalesforceV2Dataset> {
        if (!dataset) {
            dataset = this.model().create<SalesforceV2Dataset>(resource.name);
        }
        await super._toModel(resource, dataset);
        const model = resource.properties as Model.SalesforceV2ObjectDataset;
        if (model?.typeProperties) {
            ValueAdapter.toModel(dataset, SalesforceV2Dataset.TABLE_NAME, model.typeProperties.objectApiName ?? model.typeProperties.reportId);
            dataset.sourceOption = model.typeProperties.reportId != null ? 'reportId' : 'objectApiName';
        }

        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, resource, this.model()));
        return dataset;
    }
}
